// This file was auto-generated by commondatabuilder.
// Please don't edit it.

export const LEGACY_FORMSET_ADD_BUTTON_NAME = "legacyFormsetAddButton";
